﻿import $ from 'jquery';
import globals from '../../Scripts/utils/globals.js';
import { removeGroupSeparators, addGroupSeparator } from '../../Scripts/utils/string.js';
import { validators as fileUploadValidators, setupFileUpload } from '../../Scripts/form-inputs/file-upload.js';
import { validators as multiSelectValidators, setupMultiSelect } from '../../Scripts/form-inputs/multi-select.js';
import { validators as selectValidators, setupSelect } from '../../Scripts/form-inputs/select';
import { validators as checkboxValidators } from '../../Scripts/form-inputs/checkbox.js';
import setupCheckToInclude from '../../Scripts/form-inputs/check-to-include.js';
import setupVisibleWhen from '../../Scripts/form-inputs/visible-when.js';
import { setupAdderInput, inlineDelete, onAddButtonClick } from '../../Scripts/form-inputs/adder-input.js';

function preventInvalidNumerics(e) {
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    var precision = parseInt($(this).attr('data-val-number-precision') || 0, 10);
    var regex = new RegExp('[a-zA-Z~`!@#$%^&()_= {}[\\]:;\\/<>\\-\\+\\?\'|¦"£¬\\*\\\\' + globals.intl.groupSeparator + (precision == 0 ? globals.intl.decimalSeparator : '') + ']+$');

    if (regex.test(str)) {
        e.preventDefault();
    }

    var currentVal = $(this).val();

    if (precision > 0 && currentVal.includes(globals.intl.decimalSeparator)) {
        if (str == globals.intl.decimalSeparator) {
            e.preventDefault();
        }

        if (this.selectionStart > currentVal.indexOf(globals.intl.decimalSeparator) && currentVal.split(globals.intl.decimalSeparator)[1].length == precision) {
            e.preventDefault();
        }
    }
}

function preventInvalidTelephone(e) {
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    var regex = new RegExp('[a-zA-Z~`!@#$%^&()_= {}[\\]:;\\/<>\\-\\?\'|¦"£¬\\*\\\\.,]+$');

    if (regex.test(str)) {
        e.preventDefault();
    }
}

function formatNumbers(addTrailingZeros) {
    return format(function (oldValue) {
        var oldValueParts = oldValue.split(globals.intl.decimalSeparator);
        var integerPart = motivUi.string.removeGroupSeparators(oldValueParts[0].toString());
        var newIntegerPart = motivUi.string.addGroupSeparator(integerPart);
        var precision = parseInt($(this).attr('data-val-number-precision') || 0, 10);
        var fractionalPart = oldValueParts[1];

        if (precision > 0 && (fractionalPart || oldValue.includes(globals.intl.decimalSeparator))) {
            var newFractionalPart = fractionalPart.substring(0, precision);

            if (addTrailingZeros) {
                while (newFractionalPart.length < precision) {
                    newFractionalPart += '0';
                }
            }

            return newIntegerPart + globals.intl.decimalSeparator + newFractionalPart;
        } else {
            return newIntegerPart;
        }
    });
}

function format(callback, handleBackspace) {
    return function (event) {
        if (handleBackspace && event.code == "Backspace") {
            return true;
        }

        var pos = this.selectionStart;
        var oldValue = $(this).val();
        var newValue = callback.call(this, oldValue);
        $(this).val(newValue);

        if (oldValue != newValue) {
            this.selectionEnd = Math.max(pos - oldValue.length + newValue.length, 0);
        }
    }
}

function getInputValueByName(name) {
    var inputSelector = 'input[name="' + name + '"]';
    var inputType = $(inputSelector).attr("type");
    if (!inputType) {
        return $('select[name="' + name + '"] option:selected:not(:disabled)').val();
    }
    if (inputType == "checkbox" || inputType == "radio") {
        return $(inputSelector + ":checked").val();
    } else {
        return $(inputSelector).val();
    }
}

var validators = {
    ...fileUploadValidators,
    ...selectValidators,
    ...multiSelectValidators,
    ...checkboxValidators,
    requiredif: {
        parameters: ['prop', 'val'],
        isValid: function (value, element, params) {
            var desiredValues = params.val;
            desiredValues = desiredValues == null ? [''] : desiredValues.toString().split('|');
            var actualvalue = getInputValueByName(params.prop);
            for (var i = 0; i < desiredValues.length; i++) {
                if ($.trim(desiredValues[i]).toLowerCase() === $.trim(actualvalue).toLocaleLowerCase()) {
                    var isValid = $.validator.methods.required.call(this, value, element, params);
                    return isValid;
                }
            }

            return true;
        },
        unpack: function (options) {
            options.rules['requiredif'] = options.params;
            options.messages['requiredif'] = options.message;
            options.params.prop = $(options.element).attr('name').split('.').slice(0, -1).concat(options.params.prop).join('.');
            $(options.params.prop).on('keyup', function () {
                $(options.element).valid(['requiredif']);
                $(options.params.prop).valid(['requiredif']);
            });
        }
    },
    max: {
        parameters: ['value'],
        unpack: function (options) {
            options.rules['max'] = parseLocalizedFloat(options.params.value);
            options.messages['max'] = options.message;
        }
    },
    min: {
        parameters: ['value'],
        unpack: function (options) {
            options.rules['min'] = parseLocalizedFloat(options.params.value);
            options.messages['min'] = options.message;
        }
    },
    addresspopulated: {
        isValid: function (_value, _element, params) {
            return $(params.target + ' input').filter(function (_i, x) {
                return $(x).val();
            }).length > 0;
        },
        message: 'Please select your address from the drop-down list'
    },
    greaterthan: {
        parameters: ['compare', 'diff'],
        isValid: function (value, _element, params) {
            var compareVal = parseLocalizedFloat(getInputValueByName(params.compare));
            if (compareVal == undefined || value == '') {
                return true;
            }

            return parseLocalizedFloat(params.diff) + parseFloat(value) > compareVal;
        },
        message: function (params, element) {
            var compareVal = motivUi.string.removeGroupSeparators(getInputValueByName(params.compare));
            return $.validator.format($(element).attr('data-val-greaterthan'), motivUi.string.addGroupSeparator(compareVal - $(element).attr('data-val-greaterthan-diff')));
        },
        unpack: function (options) {
            options.rules['greaterthan'] = options.params;
            options.params.compare = $(options.element).attr('name').split('.').slice(0, -1).concat(options.params.compare).join('.');
            var attributeSelector = '[name=\'' + options.params.compare + '\']';
            var selector = 'input' + attributeSelector + ', select' + attributeSelector;
            $(selector).on('keyup change input', function () {
                if (getInputValueByName(options.element.name) && $(selector).valid()) {
                    $(options.element).valid(['greaterthan']);
                }
            });
        }
    },
    lessthan: {
        parameters: ['compare', 'diff'],
        isValid: function (value, _element, params) {
            var compareVal = parseLocalizedFloat(getInputValueByName(params.compare));
            if (compareVal == undefined) {
                return true;
            }

            return compareVal <= parseLocalizedFloat(params.diff) || parseLocalizedFloat(params.diff) + parseFloat(value) < compareVal;
        },
        message: function (params, element) {
            var compareVal = motivUi.string.removeGroupSeparators(getInputValueByName(params.compare));
            return $.validator.format($(element).attr('data-val-lessthan'), motivUi.string.addGroupSeparator(compareVal - $(element).attr('data-val-lessthan-diff')));
        },
        unpack: function (options) {
            options.rules['lessthan'] = options.params;
            options.params.compare = $(options.element).attr('name').split('.').slice(0, -1).concat(options.params.compare).join('.');
            $('input[name=\'' + options.params.compare + '\']').on('keyup change input', function () {
                if (getInputValueByName(options.element.name)) {
                    $(options.element).valid(['lessthan']);
                }
            });
        }
    },
    lookup: {
        isValid: function (_value, element, _params) {
            if ($(element).attr('data-val-lookup-show') == 'true') {
                return false;
            }

            if (this.currentElements.length == 1) {
                return true;
            }

            $(element).attr('data-val-lookup-show', 'true');
            return false;
        },
        unpack: function (options) {
            options.rules['lookup'] = options.params;
            options.messages['lookup'] = options.message;
        }
    },
    notequal: {
        parameters: ['compare'],
        isValid: function (value, _element, params) {
            return $(params.compare).val().replace(/\,/g, '') != value;
        },
        unpack: function (options) {
            options.rules['notequal'] = options.params;
            options.messages['notequal'] = options.message;
            options.params.compare = '#' + $(options.element).attr('id').split('_').slice(0, -1).concat(options.params.compare).join('_');
            $(options.params.compare).on('keyup', function () {
                if ($(options.element).val()) {
                    $(options.element).valid(['notequal']);
                }
            });
        }
    },
    number: {
        isValid: function (value, element, _params) {
            if (!value) {
                return true;
            }

            var precision = parseInt($(element).attr('data-val-number-precision') || 0, 10);
            if (precision > 0) {
                return new RegExp('^(?:-?\\d+|-?\\d{1,3}(?:\\' + globals.intl.groupSeparator + '\\d{3})+)\\.?(?:\\d{1,' + precision + '})?$').test(value);
            }

            return new RegExp('^[0-9\\' + globals.intl.groupSeparator + ']+$').test(value);
        }
    },
    roundedupto: {
        parameters: ['nearest'],
        isValid: function (value, _element, params) {
            return parseInt(value, 10) % params.nearest == 0;
        },
        message: function (params, element) {
            var roundedUpTo = Math.ceil(parseInt(element.value.replace(/\,/g, ''), 10) / params.nearest) * params.nearest;
            return $.validator.format($(element).attr('data-val-roundedupto'), motivUi.string.addGroupSeparator(roundedUpTo));
        },
        unpack: function (options) {
            options.rules['roundedupto'] = options.params;
            options.params.nearest = parseInt(options.params.nearest, 10);
        }
    },
    sortcode: {
        isValid: function (value, _element, _params) {
            return /^\d\d-\d\d-\d\d$/.test(value);
        },
        unpack: function (options) {
            options.rules['sortcode'] = options.params;
            options.messages['sortcode'] = options.message;
        }
    },
    telephone: {
        isValid: function (value, _element, _params) {
            return /^(\+44|0)(?!0{10})\d{10}$/.test(value);
        },
        unpack: function (options) {
            options.rules['telephone'] = options.params;
            options.messages['telephone'] = options.message;
        }
    }
}

var normalizer = function (value) {
    return value;
}

var loadingSpinnerSubmitHandler = function (_form, _event) { };

var inputFormattingSubmitHandler = function (_form, _event) { };

var submitHandler = function (form, event) {
    loadingSpinnerSubmitHandler(form, event);
    inputFormattingSubmitHandler(form, event);
    return true;
}

var parseLocalizedFloat = function (value) {
    if (value == '' || value == undefined) {
        return undefined;
    }

    return parseFloat(motivUi.string.removeGroupSeparators(value ?? "0", true));
}

var validationCalled = false;
var hasLeftPage = false;
var recentEvents = {};
var motivUi = {};

var setup = {
    eventTracking: function () {
        addEvent('', 'PageHit');
        $("input:not([type='submit']):not([type='button']):not([type='radio']),select:not([data-evt-tracking='full']),textarea").on("blur", function () {
            if ($(this).closest('[data-evt-tracking="false"]').length <= 0) {
                var eventType;
                if ($(this).val()) {
                    eventType = $(this.form).validate().check(this) ? 'Valid' : 'Invalid';
                } else {
                    eventType = 'Empty';
                }

                addEvent(this, eventType);
            }
        });

        $('select[data-evt-tracking="full"]').on("blur", function () {
            addEvent(this, $(this).val() || 'Empty');
        });

        $("input[type='radio']").on("click", function () {
            addEvent(this, $(this).val());
        });

        $("input[type='submit'],input[type='button'],a[data-evt],button[data-evt]").on("click", function () {
            addEvent(this, 'ButtonClick');
        });

        $(window).on('beforeunload unload pagehide pagecontainerhide', function () {
            if (!hasLeftPage) {
                addEvent('', 'PageLeft');
                hasLeftPage = true;
            }
        });

        return setup;
    },
    inputFormatting: function () {
        if (!validationCalled) {
            throw 'Must be called after validation.'
        }

        $('input[data-val-number], input[data-val-sortcode]')
            .off('keypress.inputFormatting')
            .on('keypress.inputFormatting', preventInvalidNumerics);
        $('input[data-val-number]:not([type="hidden"]):not([data-val-number-formatted="false"])')
            .off('keyup.inputFormatting')
            .on('keyup.inputFormatting', formatNumbers(false))
            .off('blur.inputFormatting')
            .on('blur.inputFormatting', formatNumbers(true))
            .each(formatNumbers(true));
        $('input[data-val-sortcode]')
            .off('keydown.inputFormatting blur.inputFormatting')
            .on('keydown.inputFormatting blur.inputFormatting', format(function (newValue) {
                newValue = newValue === 0 ? '0' : newValue;
                newValue = (newValue || '') && newValue.toString().replace(/-/g, '');
                return newValue.replace(/(\d{2})+?/g, '$1-').substring(0, 8);
            }, true));
        $('input[data-val-telephone]')
            .off('keypress.inputFormatting')
            .on('keypress.inputFormatting', preventInvalidTelephone);

        normalizer = function (value) {
            if (typeof value !== 'string') {
                return '';
            }

            if ($(this).attr('data-val-number')) {
                return motivUi.string.removeGroupSeparators(value);
            }

            return value;
        };

        inputFormattingSubmitHandler = function (form, _event) {
            $(form).find('input[data-val-number]').each(motivUi.callback.removeGroupSeparators(false));
        };

        return setup;
    },
    loadingSpinner: function (submitSelector, submitLoadingClass, submitLoadingCurrentClass) {
        if (!validationCalled) {
            throw 'Must be called after validation.'
        }

        loadingSpinnerSubmitHandler = function (form, event) {
            $(form).find(submitSelector || 'button[type="submit"]').addClass(submitLoadingClass || 'loading');

            if (submitLoadingCurrentClass) {
                $(event.originalEvent.submitter).addClass(submitLoadingCurrentClass);
            }
        }

        return setup;
    },
    timeAt: function (parentSelector) {
        function valid(month, yearRequired, year) {
            return month && (!yearRequired || year);
        }

        function calculateNumberOfMonths(year, month, format, yearRequired) {
            if (!valid(month, yearRequired, year)) {
                return null;
            }

            switch (format) {
                case "number":
                    return parseInt(year || 0, 10) * 12 + parseInt(month, 10);
                case "date":
                    var currentTime = new Date();
                    return (currentTime.getFullYear() - parseInt(year, 10)) * 12 + (currentTime.getMonth() - parseInt(month, 10) + 1);
                default:
                    throw `Format ${format} not supported.`;
            }
        }

        function setTimeAt(field, blur, format) {
            return function () {
                var monthInput = $(field + '_Month');
                var yearInput = $(field + '_Year');
                var month = monthInput.val();
                var year = yearInput.val();
                var yearRequired = format == "date";
                var numberOfMonths = calculateNumberOfMonths(year, month, format, yearRequired);

                if (numberOfMonths != null) {
                    $(field).val(numberOfMonths);

                    if (!blur) {
                        $(field).trigger('input');
                    }
                } else {
                    $(field).val("");
                }

                var validate = $(this.form).validate();
                if (valid(validate.invalid.hasOwnProperty(monthInput.attr('name')),
                    yearRequired,
                    validate.invalid.hasOwnProperty(yearInput.attr('name')))) {
                    $(field).valid();
                    if (blur) {
                        $(field).trigger('blur');
                    }
                }
            }
        }

        var dataTimeAt = $('[data-time-at="true"]');

        if (parentSelector) {
            dataTimeAt = $(parentSelector).find('[data-time-at="true"]');
        }

        dataTimeAt.each(function (_i, x) {
            var id = '#' + x.id;
            var format = $(id).attr('data-time-at-format') ?? 'date';
            $(id).attr('data-val-always', 'true');
            $(id).attr('data-val-focus-in', `${id}_Year`);
            $(id + '_Month, ' + id + '_Year')
                .on('blur', setTimeAt(id, true, format))
                .attr('data-evt-tracking', 'false');

            $(id + '_Month').on('change', setTimeAt(id, false, format));
            $(id + '_Year').on('input', setTimeAt(id, false, format));
            var timeAt = $(id).val();
            var startDate = new Date();

            if (timeAt) {
                if (format == "date") {
                    startDate.setMonth(startDate.getMonth() - parseInt(timeAt, 10));
                    $(id + '_Month').val(startDate.getMonth() + 1);
                    $(id + '_Year').val(startDate.getFullYear());
                }
                else if (format == "number") {
                    $(id + '_Year').val(Math.floor(timeAt / 12));
                    $(id + '_Month').val(timeAt % 12);
                }
            }
        });

        return setup;
    },
    fileUpload: function (parentSelector) {
        setupFileUpload(parentSelector);
        return setup;
    },
    multiSelect: function () {
        setupMultiSelect();
        return setup;
    },
    checkToInclude: function () {
        setupCheckToInclude();
        return setup;
    },
    select: function () {
        setupSelect();
        return setup;
    },
    visibleWhen: function (parentSelector) {
        setupVisibleWhen(parentSelector);
        return setup;
    },
    adderInput: function(pageUpdateCallback) {
        setupAdderInput(pageUpdateCallback);    
        return setup;
    },
    validation: function (ignore, highlight, unhighlight) {
        validationCalled = true;
        var oldDefaults = $.extend({}, $.validator.defaults);
        var defaults = {
            ignore: ignore || ':hidden:not([data-val-always="true"]), .question:hidden *',
            normalizer: function (value) {
                return normalizer.call(this, value);
            },
            submitHandler: function (form, event) {
                return submitHandler(form, event);
            }
        }

        if (highlight) {
            defaults.highlight = function (element, errorClass, validClass) {
                oldDefaults.highlight.call(this, element, errorClass, validClass);
                highlight.call(this, element, errorClass, validClass);
            }
        }

        if (unhighlight) {
            defaults.unhighlight = function (element, errorClass, validClass) {
                oldDefaults.unhighlight.call(this, element, errorClass, validClass);
                unhighlight.call(this, element, errorClass, validClass);
            }
        }

        $.validator.setDefaults(defaults);

        $.validator.prototype.focusInvalid = function () {
            if (this.settings.focusInvalid) {
                try {
                    var lastActive = $(this.findLastActive() || this.errorList.length && this.errorList[0].element || []);
                    var focusIn = lastActive.attr("data-val-focus-in") || lastActive.filter(":visible");
                    $(focusIn)
                        .focus()
                        .trigger("focusin");

                } catch (e) {
                    // Ignore IE throwing errors when focusing hidden elements
                }
            }
        }

        Object.keys(validators).forEach(function (key) {
            var validator = validators[key];
            if (validator.isValid) {
                $.validator.addMethod(key, validator.isValid, validator.message);
            }

            if (validator.unpack) {
                $.validator.unobtrusive.adapters.add(key, validator.parameters || [], validator.unpack);
            }
        });

        return setup;
    }
}

function addEvent(selectorOrName, type, submissionProductId) {
    var name = $(selectorOrName).data("evt") || $(selectorOrName).attr("name") || selectorOrName || '';

    if (!globals.sessionGuid) {
        return;
    }

    if (Object.keys(recentEvents).length == 0) {
        setTimeout(function () { recentEvents = {} }, 50)
    }

    if (recentEvents[name + type]) {
        return;
    }

    submissionProductId = globals.submissionProductId || submissionProductId;
    recentEvents[name + type] = true;
    sendBeacon("/Event/Log?page=" + (globals.pageTitle || window.location.pathname.replace(/^\/(.*)/, '$1').split('?')[0] || 'Index')
        + "&name=" + name
        + "&eventType=" + type
        + (globals.submissionId ? "&submissionId=" + globals.submissionId : "")
        + (submissionProductId ? "&submissionProductId=" + submissionProductId : "")
        + (globals.sessionGuid ? "&sessionId=" + globals.sessionGuid : ""));
}

function sendBeacon(postUrl) {
    postUrl = globals.routing.pathBase + postUrl;
    var beacon = window.navigator && navigator.sendBeacon && navigator.sendBeacon.bind(navigator);

    if (beacon) {
        try {
            beacon(postUrl + "&beacon=true", "");
            return;
        } catch (e) {
            // swallow error and fallback to ajax call
        }
    }

    $.ajax({
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: "POST",
        url: postUrl
    });
}

var localStorageAvailable = (function () {
    try {
        localStorage.setItem('localStorage', 'true');
        localStorage.removeItem('localStorage');
        return true;
    } catch (e) {
        return false;
    }
})();

var sessionStorageAvailable = (function () {
    try {
        sessionStorage.setItem('sessionStorage', 'true');
        sessionStorage.removeItem('sessionStorage');
        return true;
    } catch (e) {
        return false;
    }
})();

motivUi.addEvent = addEvent;
motivUi.callback = {
    removeCommas: function () {
        var nStr = $(this).val();
        nStr = nStr.replace(/,/g, '');
        $(this).val(nStr);
    },
    removeGroupSeparators: function (replaceDecimalSeparator) {
        return function () {
            var nStr = motivUi.string.removeGroupSeparators($(this).val(), replaceDecimalSeparator);
            $(this).val(nStr);
        }
    },
    formatNumbers: formatNumbers
};

motivUi.globals = globals;
motivUi.sendBeacon = sendBeacon;
motivUi.setup = setup;
motivUi.string = {
    addCommas: function (newValue) {
        newValue = newValue === 0 ? '0' : newValue;
        newValue = (newValue || '') && newValue.toString().replace(/,/g, '');
        return newValue.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    },
    addGroupSeparator: addGroupSeparator,
    removeGroupSeparators: removeGroupSeparators,
};
motivUi.adder = {
    inlineDelete: inlineDelete,
    onAddButtonClick: onAddButtonClick
}

motivUi.onTrigger = function (events, selector, callback) {
    $(selector).on(events, callback);
    callback.call($(selector)[0]);
};

motivUi.supported = {
    localStorage: localStorageAvailable,
    sessionStorage: sessionStorageAvailable
}

export default motivUi;